import axios from 'axios'

export const all = (): Promise<any> => {
  return axios.get('/disciplines')
}

export const deleteTeacherAssociation = (id: number, teacherId: number): Promise<any> => {
  return axios.delete(`/disciplines/${id}/teachers/${teacherId}/association`)
}
